module.exports = __webpack_public_path__ + "img/Bell.e4b3188f.svg";